/**
 * ページ読み込み完了後のフェードイン
 * - 読み込み中: html.is-page-fade body { opacity: 0; }
 * - load後: html.is-page-fade.is-loaded body { opacity: 1; transition... }
 * - フェード完了後にクラスを外して、hoverのopacity変更を邪魔しない
 *
 * 前提:
 * - functions.php の wp_head（priority 0）で html に is-page-fade を付与する
 * - SCSS側でフェード用スタイルを定義している
 */
const pageFadeIn = () => {
  window.addEventListener('load', () => {
    const root = document.documentElement;

    if (!root.classList.contains('is-page-fade')) return;

    root.classList.add('is-loaded');

    const body = document.body;
    let timerId = null;

    const cleanup = () => {
      root.classList.remove('is-page-fade', 'is-loaded');
      body.removeEventListener('transitionend', onEnd);
      if (timerId) window.clearTimeout(timerId);
    };

    const onEnd = (event) => {
      if (event.target === body && event.propertyName === 'opacity') cleanup();
    };

    body.addEventListener('transitionend', onEnd);

    // 予備（transitionendが発火しないケース用）
    timerId = window.setTimeout(() => {
      cleanup();
    }, 1000);
  });
};

export { pageFadeIn };
